import React, { useState } from "react";
import {
  Card,
  Form,
  Select,
  DatePicker,
  Typography,
  Button,
  Space,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterCard = ({ categories, subcategories, tags, onFilter }) => {
  const [form] = Form.useForm();

  const applyFilters = (values) => {
    onFilter({
      category: values.category || null,
      subcategory: values.subcategory || null,
      dateRange: values.dateRange || [],
      tags: values.tags || [],
    });
  };

  const resetAll = () => {
    form.resetFields();
    onFilter({ category: null, subcategory: null, dateRange: [], tags: [] });
  };

  return (
    <Card
      bordered={false}
      style={{
        width: 320,
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Title level={4} style={{ margin: 0 }}>
          Filters
        </Title>

        <Form
          form={form}
          layout="vertical"
          onFinish={applyFilters}
        >
          <Form.Item name="category" label={<Text strong>Category</Text>}>
            <Select
              placeholder="Select category"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {categories.map((cat) => (
                <Option key={cat} value={cat}>
                  {cat}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="subcategory" label={<Text strong>Sub-category</Text>}>
            <Select
              placeholder="Select sub-category"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {subcategories.map((sub) => (
                <Option key={sub} value={sub}>
                  {sub}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="dateRange" label={<Text strong>Date Range</Text>}>
            <RangePicker
              style={{ width: "100%" }}
              allowClear
              format="MMM D, YYYY"
            />
          </Form.Item>

          <Form.Item name="tags" label={<Text strong>Tags</Text>}>
            <Select
              mode="multiple"
              placeholder="Select tags"
              allowClear
              maxTagCount="responsive"
            >
              {tags.map((tag) => (
                <Option key={tag} value={tag}>
                  {tag}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Button
                type="default"
                icon={<ReloadOutlined />}
                onClick={resetAll}
              >
                Reset
              </Button>
              <Button type="primary" htmlType="submit">
                Apply Filters
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Space>
    </Card>
  );
};

export default FilterCard;
